/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_UserInputs */

const en_admin_payments_user = /** @type {(inputs: Admin_Payments_UserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User`)
};

/**
* | output |
* | --- |
* | "User" |
*
* @param {Admin_Payments_UserInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_user = /** @type {((inputs?: Admin_Payments_UserInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_UserInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_user(inputs)
});
export { admin_payments_user as "admin.payments.user" }